const INITIAL_STATE = {
  initialValidationAttributes: {
    documentReview: null,
  },
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DEFAULT_DOCUMENT_VALIDATION_ATTRIBUTES': {
      return {
        ...state,
        initialValidationAttributes: {
          ...state.initialValidationAttributes,
          documentReview: action.payload.documentReview,
        },
      };
    }
    default:
      return state;
  }
};

export { reducer };
